
import { defineComponent, ref, reactive, toRefs, inject, computed, onMounted, watch } from "vue";
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { ErrorMessage, Field, Form } from 'vee-validate';
import * as _ from "lodash";


  export default defineComponent({
    name: 'FormCheckboxInput',
    components: {
      Field,
      ErrorMessage,
    },
    props: ['item', 'items', 'iterator'],
    setup(props, context) {
      const helpers: any = inject('helpers');
      const i18n = useI18n();

      const state = reactive({
        item: props.item,
        items: props.items,
        iterator: props.iterator,
      });

      onMounted(() => {
        if (!state.item.values) {
          triggerChange([]);
        }
      });

      watch(
        () => state.item.values,
        (values, prevCount) => {
          triggerChange(values);
        },
      );

      const triggerChange = (selection = []) => {
        selection = JSON.parse(JSON.stringify(selection))
        let item: any = state.item;
        let iterator: any = state.iterator;
        let all_sections_keys: any = getAllSections(item);
        let selected_section_values: any = getSelectValue(item, selection);
        let difference:any = all_sections_keys.filter(x => !_.map(selected_section_values,'model_key').includes(x));

        // remove item
        let removalKeys: any = difference;
        _.remove(state.items, function(currentObject: any) {
          return removalKeys.includes(currentObject.model_key);
        });

        _.forEach(selected_section_values,(section)=>{
          if (!checkIfSectionAdded(state.items,section.model_key)){
            state.items.splice(iterator + 1 , 0, cloneSection(section));
          }
        });
      };

      const cloneSection = (section) => {
        let clonedSectionItem: any = Object.assign({}, section);
        clonedSectionItem.key = `_main_${Math.random().toString(16)}`;
        clonedSectionItem.section_repeat_index = 1;

        let itemsR: any = [];
        _.forEach(clonedSectionItem.items, (oldItem) => {
          // oldItem = JSON.parse(JSON.stringify(oldItem));
          oldItem.key = `_sub_${Math.random().toString(16)}`;
          oldItem.value = null;
          oldItem.values = [];
          if(oldItem.type != "Section") itemsR.push(oldItem);
        });
        return clonedSectionItem;
      };

      const getSelectValue = (item, values) => {
        let Gitems: any = [];
        _.forEach(item.selection_values, (_item) => {
          if (values.includes(_item.id) && _item.section) {
            Gitems.push(JSON.parse(JSON.stringify(_item.section)));
          }
        });

        return Gitems;
        // return _.filter(Gitems,(i) => {
        //   return i.section;
        // });
      };
      const getAllSections = (item) => {
        let Gitems: any = [];
        _.forEach(item.selection_values, (_item) => {
          if (_item.section) {
            Gitems.push(JSON.parse(JSON.stringify(_item)));
          }
        });
        return _.map(Gitems,"section.model_key");
      };

      const checkIfSectionAdded = (items, modelKey) => {
        for (let i = 0; i < items.length; i++) {
          if (items[i].model_key == modelKey) {
            return true;
          }
        }
        return false;
      };
      return {
        ...toRefs(state),
        i18n,
        helpers,
      };
    },
  });
